import Typography from "../shared/typography";
import { cn } from "../utls/utils";

export type RecordMetaItem = {
  label: string;
  value?: string | null;
};

interface RecordMetaGridProps {
  items?: RecordMetaItem[];
  className?: string;
  columnsClassName?: string;
}

const baseColumnClasses = "grid gap-4 sm:grid-cols-2 lg:grid-cols-3";

export function RecordMetaGrid({
  items,
  className,
  columnsClassName,
}: RecordMetaGridProps) {
  if (!items || items.length === 0) {
    return null;
  }

  return (
    <dl className={cn(baseColumnClasses, columnsClassName, className)}>
      {items.map((item) => (
        <div key={`${item.label}-${item.value ?? ""}`} className="space-y-1">
          <Typography
            variant="caption"
            className="font-semibold uppercase tracking-wide text-brown-600"
          >
            {item.label}
          </Typography>
          <Typography variant="body2" className="text-brown-900">
            {item.value ?? "—"}
          </Typography>
        </div>
      ))}
    </dl>
  );
}

export default RecordMetaGrid;
